/*
 * @Author: jitsutou.tei 
 * @Date: 2021-08-25 10:27:49 
 * @Last Modified by: jitsutou.tei
 * @Last Modified time: 2022-11-02 14:54:48
 */

//生成随机数

function randPwd(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
         pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

function randStr(len) {
    len = len || 32;
    var $chars = 'abcdefhijkmnprstwxyz23456789';
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
         pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

function randNumStr(len) {
    len = len || 32;
    var $chars = '123456789';
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
         pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

function randNum(Min,Max) {
    if(Min>Max){
         return Min;
    }
    var Range = Max - Min;
    var Rand = Math.random();
    return(Min + Math.round(Rand * Range));
}

export {
    randStr,
    randPwd,
    randNumStr,
    randNum
}